module.exports = __webpack_public_path__ + "img/Profil_VP-Lite_Standard.c7761d65.jpg";